var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacySandboxWhite = function SvgPrivacySandboxWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M11.293 11.293c2.6-2.6 3.233-6.18 1.414-8-1.82-1.819-5.4-1.186-8 1.414s-3.233 6.18-1.414 8c1.82 1.819 5.4 1.186 8-1.414Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M8 14.657A6.656 6.656 0 1 0 8 1.344a6.656 6.656 0 0 0 0 13.313Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.823 2.808H3.317a.682.682 0 1 1 0-1.365h1.506a.682.682 0 1 1 0 1.365M3.518 10.195v.922c0 .885-.585 1.704-1.373 1.946-.787-.243-1.371-1.058-1.371-1.946v-.923l1.372-.61zM13.126 4.741a1.373 1.373 0 1 0 0-2.745 1.373 1.373 0 0 0 0 2.745M8.833 7.618a1.336 1.336 0 1 0-1.89-1.889 1.336 1.336 0 0 0 1.89 1.89M5.372 10.3c0-.538.32-1.025.814-1.236a4.65 4.65 0 0 1 3.712 0c.495.21.814.698.814 1.235v.382h-5.34zM13.05 13.062h-2.344l-.371.683.37.682h2.344l.372-.682z"
  })));
};
export default SvgPrivacySandboxWhite;